import { take, put, call, all, select } from 'redux-saga/effects';
import { requestHandler } from '../../../../../service/fetcher.saga';

function* savePartnerTaxRate() {
	while (true) {
		yield take('SAVE_PARTNER_TAX_RATE');

		const { exports } = yield select();
		let tax_rates = exports.partnerTaxRates;
		tax_rates = tax_rates.filter(tr => !isNaN(parseFloat(tr.tax_rate)));
		tax_rates = tax_rates.map(tr => {
			tr.tax_rate = (parseFloat(tr.tax_rate) / 100).toFixed(4);
			return tr;
		});

		const { result } = yield call(
			requestHandler,
			'partners',
			'POST',
			{ partner_tax_rates: tax_rates },
			'taxRates'
		);
		if (result) yield put({ type: 'RECEIVE_PARTNER_TAX_RATES', data: result });
	}
}

export default function* indexSaga() {
	yield all([savePartnerTaxRate()]);
}
